module.exports = __webpack_public_path__ + "static/img/product_5.4931ed22.png";